export const LOCAL_STORAGE = {
  SCHEDULE_SESSION: "scheduleSession",
  SCHEDULE_FILTERS: "scheduleFilters",
};
